import { render, staticRenderFns } from "./ResourceNewPage.vue?vue&type=template&id=c0683b40"
import script from "./ResourceNewPage.vue?vue&type=script&lang=ts"
export * from "./ResourceNewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports